<template>
	<div>
		<div class="cart__products">
			<cart-item v-if="checkItems" v-for="item in cartItems" :item="item" :key="item.cart_id" v-on:updateCount="onUpdateItem" v-on:removeFromCart="onRemoveItem"></cart-item>
			<div v-if="!checkItems">
				<h3 class="cart__empty">Ваша корзина пуста. Добавьте товары в корзину</h3>
			</div>
		</div>
		<div class="cart__wrap" v-if="checkItems">
			<div class="cart__profile" v-if="!checkPaidlessOrder">
				<order :cart="items.cart"></order>
			</div>
			<div v-else>
				<p class="cart__warn">Вы не можете сделать новый заказ. Для продолжения, оплатите полностью текущий активный заказ.</p>
			</div>
		</div>
	</div>
</template>

<script>
  import { bus } from './bus.js'
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import cartItem from './cart-item'
  import order from './order'

  export default {
    name: "big-cart",
    data() {
      return {
        cartItems: '',
        packPrice: '',
        total: {
          cart: 0,
        }
      }
    },
    components: { cartItem, order },
    props: {
      url: '',
      items: '',
	    user: ''
    },
    computed: {
      checkItems() {
        if ($.isEmptyObject(this.cartItems) || Object.keys(this.cartItems).length == 0) {
          return false;
        } else {
          return true;
        }
      },
      checkPaidlessOrder(){
        if (this.user.paidless_order) {
          return true;
        } else {
          return false;
        }
	    }
    },
    watch: {
      'cartItems': 'setItemsPrice'
    },
    methods: {
      setPackPrice(price) {
        this.total.pack = price * 1;
      },
      setItemsPrice() {
        let price = 0;
        for (let key in this.cartItems) {
          price = price * 1 + this.cartItems[key].total * 1;
        }
        this.total.cart = price;
      },
      onRemoveItem(data) {
        Vue.delete(this.cartItems, data);
      },
      onUpdateItem(data) {
        this.cartItems[data.retId] = data;
        this.setItemsPrice();
      }
    },
    mounted() {
      if (this.items) {
        this.cartItems = this.items.cart;
      }
      this.setItemsPrice();
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// themes/oprava/src/js/components/commerce/big-cart.vue